/** This adds some extra spacing under the input fields where necessary. SDC Android bug puts soft keyboard on top of input field. */
export function SDCAndroidBugSpacer() {
  return <div className="min-h-[50vh]" />;
}
